import Link from 'next/link'
import { useEffect } from 'react'

export const EmptyCart = () => {
    return (
        <div className={'EmptyCart'}>
            <div className={'empty-cart-content'}>
                <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="154"
                    height="156"
                    viewBox="0 0 154 156"
                    fill="none"
                >
                    <path
                        d="M3.06641 2.85449H9.46404C13.4829 2.85449 16.9293 5.72283 17.6589 9.67493L36.3997 111.188H127.206C131.087 111.188 134.454 108.509 135.326 104.728L150.711 38.0617C151.916 32.8399 147.95 27.8545 142.591 27.8545H23.8997M128.066 152.854C123.464 152.854 119.733 149.124 119.733 144.521C119.733 139.919 123.464 136.188 128.066 136.188C132.669 136.188 136.4 139.919 136.4 144.521C136.4 149.124 132.669 152.854 128.066 152.854ZM44.7331 152.854C40.1307 152.854 36.3997 149.124 36.3997 144.521C36.3997 139.919 40.1307 136.188 44.7331 136.188C49.3354 136.188 53.0664 139.919 53.0664 144.521C53.0664 149.124 49.3354 152.854 44.7331 152.854Z"
                        stroke="#040404"
                        strokeWidth="5"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                    />
                </svg>
                <div className={'text'}>
                    <h1>Ваша корзина пуста, добавьте товары</h1>
                    <Link href={'/vsja-produktsija'}>Перейти в каталог</Link>
                </div>
            </div>
        </div>
    )
}
